<!--===========================
=            BADGE            =
============================-->
<template>
  <div class="justify-start ml-n2"
   
  >
   
    <v-chip label dense  x-small
      class="ma-2 white--text"
     :color="`${color} lighten-3`"
      outlined
    >
      <v-icon  small left>
      label

      </v-icon>
     <span>
      <slot></slot>
    </span>
    </v-chip>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "success",
    },
  },
};
</script>



<!--====  End of BADGE  ====-->
